export const MAX_UPLOAD_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
export const MAX_UPLOAD_FILE_SIZE_MB = MAX_UPLOAD_FILE_SIZE / (1024 * 1024);
